import React from "react";
import { FlaskConical, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Shared";
import { chalkitLink } from "../data/mock";

export function LabsCards({ idPrefix = "labs" }) {
  return (
    <>
      <Reveal>
        <Eyebrow>Longevity + Performance Labs</Eyebrow>
        <h2 className="font-heading font-extrabold uppercase text-4xl lg:text-5xl text-white leading-[0.95] tracking-tight">
          Know your numbers.<br /><span className="text-neutral-600">Then train to move them.</span>
        </h2>
        <p className="mt-6 text-neutral-400 text-base leading-relaxed max-w-2xl">
          Comprehensive bloodwork panels built for athletes and longevity — hormones, metabolic markers, inflammation and more. Order
          directly, then review the results with your coach.
        </p>
      </Reveal>
      <div className="mt-10 grid sm:grid-cols-2 gap-5 max-w-3xl">
        {[
          { name: "Men's Longevity + Performance Labs", key: "labsMen" },
          { name: "Women's Longevity + Performance Labs", key: "labsWomen" },
        ].map((l, i) => (
          <Reveal key={l.key} delay={i * 90}>
            <a
              href={chalkitLink(l.key)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`${idPrefix}-${l.key}-cta`}
              className="block group p-7 bg-[#121214] border border-white/8 hover:border-[#9D0423]/60 transition-colors h-full"
            >
              <FlaskConical size={20} className="text-[#9D0423]" />
              <h3 className="mt-4 font-heading font-bold uppercase text-lg text-white tracking-tight">{l.name}</h3>
              <p className="mt-2 text-[13px] text-neutral-400 leading-relaxed">Full panel with special member pricing — order via ChalkIt Pro.</p>
              <span className="mt-4 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-neutral-500 group-hover:text-[#9D0423] transition-colors">
                Order Labs <ArrowRight size={13} />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </>
  );
}
